var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusRoundIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.121,
    height: 22.121,
    viewBox: "0 0 22.121 22.121",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M24.858,13.717H17.4V6.263a1.845,1.845,0,0,0-3.687,0v7.454H6.263a1.845,1.845,0,0,0,0,3.687h7.454v7.454a1.845,1.845,0,0,0,3.687,0V17.4h7.454a1.845,1.845,0,0,0,0-3.687Z",
    transform: "translate(-4.5 -4.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusRoundIcon);
export default __webpack_public_path__ + "static/media/plus-round-icon.c897f9625c0f5dd3c27c1be8d7ddd72e.svg";
export { ForwardRef as ReactComponent };